// src/mixins/responsive.js

export default {
  data() {
    return {
      isMobile: false // This will be reactive
    };
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 769; // Update the reactive data property
    }
  },
  created() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }
};
